{
  "Personel Listesi": "Personeelslijst",
  "İzin Rapor": "Verlofrapport",
  "personel": {
    "Ad Soyad": "Naam Achternaam",
    "Adres": "Adres",
    "Aç": "Openen",
    "Açıklama": "Beschrijving",
    "Banka": "Bank",
    "Banka Güncelle": "Bank Bijwerken",
    "Başlangıç Tarih": "Startdatum",
    "Belge Tür": "Documenttype",
    "Bilgi Notu": "Informatie Notitie",
    "Bitiş Tarih": "Einddatum",
    "Bölüm": "Afdeling",
    "Cep": "Mobiel",
    "Cinsiyet": "Geslacht",
    "Dosya": "Bestand",
    "Dosya yok": "Geen bestand",
    "Dosyalar": "Bestanden",
    "Doğum Tarih": "Geboortedatum",
    "Doğum Tarihi": "Geboortedatum",
    "Durum": "Status",
    "Düşünceler": "Opmerkingen",
    "E-mail": "E-mail",
    "Evlilik Tarihi": "Huwelijksdatum",
    "Eğitim": "Opleiding",
    "Fakülte": "Faculteit",
    "Form Yazdır": "Formulier Afdrukken",
    "Gün Dakika": "Dag Minuut",
    "IBAN": "IBAN",
    "IndirGoruntule": "Downloaden/Bekijken",
    "Is_Bas_Tar": "Indiensttreding",
    "Izin Rapor": "Verlofrapport",
    "Kalan Ücretli İzin Günü": "Resterende Betaalde Verlofdagen",
    "Kalan İzin": "Resterend Verlof",
    "Kan Grubu": "Bloedgroep",
    "Kart No": "Kaartnummer",
    "Kayıtlı aşama bulunamadı": "Geen geregistreerde fase gevonden.",
    "Kimlik No": "Identiteitsnummer",
    "Koordinat X (Enlem)": "Coördinaat X (Breedtegraad)",
    "Koordinat Y (Boylam)": "Coördinaat Y (Lengtegraad)",
    "Koordinat Çek": "Coördinaten Ophalen",
    "Kullanıcı": "Gebruiker",
    "Kurum/Okul": "Instelling/School",
    "Madde": "Item",
    "Medeni Durum": "Burgerlijke Staat",
    "Medeni Hal": "Burgerlijke Staat",
    "Not": "Notitie",
    "Personel": "Personeel",
    "Personel Dosyaları": "Personeelsdossiers",
    "Personel Listesi": "Personeelslijst",
    "Personel Profil": "Personeelsprofiel",
    "Resim": "Afbeelding",
    "Sicil No": "Registratienummer",
    "Tarih": "Datum",
    "Tarihi": "Datum",
    "Telefon": "Telefoon",
    "Teslim Tarihi": "Leveringsdatum",
    "Tüm Personel Dosyaları": "Alle Personeelsdossiers",
    "Yakınlık": "Nabijheid",
    "Yemek Durum": "Maaltijd (Actief/Passief)",
    "Yemek Kart Tipi": "Maaltijdkaart Type",
    "Yeni Banka": "Nieuwe Bank",
    "Ara": "Zoeken",
    "Temizle": "Wissen",
    "Kapat": "Sluiten",
    "Yenile": "Vernieuwen",
    "Zimmet": "Verduistering",
    "diger": "Overig",
    "kimlikno": "Identiteitsnummer",
    "mazaret": "Excuus",
    "rapor": "Rapport",
    "toplam": "Totaal",
    "ucretli": "Betaald",
    "ucretsiz": "Onbetaald",
    "Çocuk Sayısı": "Aantal Kinderen",
    "Öğrenim": "Opleiding",
    "Ürün": "Product",
    "İade Tarih": "Retourdatum",
    "İade Tarihi": "Retourdatum",
    "İzin": "Verlof",
    "İzin Hakediş Tar": "Vergunningsdatum verlof",
    "İzin Hakediş Tarihi": "Datum van Verlofrecht",
    "İzin Rapor": "Verlofrapport",
    "İzin Yenile": "Verlof vernieuwen",
    "İzinli Gün": "Verlofdag",
    "İş Başlangıç": "Werk Start",
    "İş Başlangıç Tarihi": "Datum van Indiensttreding",
    "İş Bitiş": "Einddatum",
    "İş Bitiş Tarihi": "Uitdiensttredingsdatum",
    "İş Giriş Aşamaları": "Werk Instapfasen",
    "İş Çıkış Aşamaları": "Werk Uitstapfasen",
    "Şube": "Tak"
  }
}
